import { render } from "./WarningPanel.vue?vue&type=template&id=4130a11a"
import script from "./WarningPanel.vue?vue&type=script&lang=js"
export * from "./WarningPanel.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__